import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div<{ withoutMargin: boolean; withoutBackground: boolean }>`
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${rem(8)};
    padding: ${rem(25)};
    margin-top: ${(props) => (props.withoutMargin ? 0 : rem(60))};
`;

export const Content = styled.div`
    display: flex;
`;

export const Image = styled.img`
    min-width: ${rem(80)};
    height: ${rem(80)};
    border-radius: 50%;
    min-height: ${rem(80)};
    height: ${rem(80)};

    @media (min-width: ${breakpoints.xs}px) {
        min-height: ${rem(105)};
        min-width: ${rem(105)};
    }
`;

export const Details = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: ${rem(25)};
    position: relative;
    width: 100%;

    @media (min-width: ${breakpoints.sm}px) {
        justify-content: center;
    }
`;

export const Question = styled.span`
    font-size: ${({ theme }) => theme.fontSizes.h5};
    padding-bottom: ${rem(15)};
    display: block;
    line-height: ${rem(30)};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
`;

export const Label = styled.span`
    padding-bottom: ${rem(15)};
    line-height: ${rem(26)};
  
    a {
        color: ${({ theme }) => theme.colors.primary};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }
`;

export const Phone = styled.div`
    a {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        color: ${({ theme }) => theme.colors.primary};
    }
`;
